import {
    Box,
    Card,
    CardContent,
    Dialog,
    Divider,
    Typography,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import React, { useState } from "react";
import dayjs, { Dayjs } from "dayjs";
import {
    FilterDialogFooter,
    FilterDialogHeader,
    PillToggleButton,
} from "../filter_dialog/filter_dialog_parts";
import { black, purple } from "../../../../theme/colors";

interface usersDownloadFilters {
    status: null | number;
    setStatus: (val: null | number) => void;
    openModal: boolean;
    setOpenModal: (val: boolean) => void;
    startDate: string;
    setStartDate: (value: string) => void;
    endDate: string;
    setEndDate: (value: string) => void;
    resetFilter: () => void;
    statusList: { id: number, value: string }[]
}

export default function UsersDownloadFilters({
    openModal,
    setOpenModal,
    setStartDate,
    endDate,
    setEndDate,
    resetFilter,
    statusList,
    setStatus
}: usersDownloadFilters) {
    const [_endDate, _setEndDate] = useState<string>(endDate);
    const [_startDate, _setStartDate] = useState<string>(endDate);
    const [_status, _setStatus] = useState<number | null>(null)

    function resetAll() {
        resetFilter();
        _setEndDate("");
        _setStartDate("");
        setOpenModal(false);
        _setStatus(null);
    }

    return (
        <Dialog open={openModal} PaperProps={{ sx: { borderRadius: 3 } }}>
            <Box sx={{ width: 420, maxWidth: "90vw" }}>
                <Card elevation={0} sx={{ px: 1 }}>
                    <FilterDialogHeader
                        title="Filter Downloads"
                        onClose={() => setOpenModal(false)}
                        onReset={resetAll}
                    />
                    <CardContent sx={{ maxHeight: 420, overflow: "auto scroll" }}>
                        <Typography fontSize={14} fontWeight="700" color={black} mb={1}>
                            Status
                        </Typography>
                        <Box>
                            {statusList?.map((item) => (
                                <PillToggleButton
                                    key={item.id}
                                    label={item.value}
                                    active={_status === item?.id}
                                    onClick={() => {
                                        if (_status === item?.id) {
                                            _setStatus(null);
                                        } else {
                                            _setStatus(item?.id);
                                        }
                                    }}
                                />
                            ))}
                        </Box>

                        <Divider sx={{ mt: 2, mb: 1 }} />
                        {_dateRange({
                            title: "Date Range",
                            setEndDate: _setEndDate,
                            setStartDate: _setStartDate,
                            startDate: _startDate,
                            endDate: _endDate,
                        })}
                        <FilterDialogFooter
                            onCancel={() => setOpenModal(false)}
                            onApply={() => {
                                setStartDate(_startDate);
                                setEndDate(_endDate);
                                setOpenModal(false);
                                setStatus(_status);
                            }}
                        />
                    </CardContent>
                </Card>
            </Box>
        </Dialog>
    );



    function _dateRange({
        title,
        startDate,
        setStartDate,
        endDate,
        setEndDate,
    }: {
        title: string;
        startDate: string;
        setStartDate: (value: string) => void;
        endDate: string;
        setEndDate: (value: string) => void;
    }) {
        return (
            <Box pt={2} pb={1}>
                <Typography fontSize={14} fontWeight="700" color={black}>
                    {title}
                </Typography>
                <Box pt={1} pb={2} display="flex" flexDirection={"column"}>
                    <DatePicker
                        label="Start Date"
                        format="DD-MM-YYYY"
                        disableFuture
                        value={startDate ? dayjs(startDate, "YYYY-MM-DD") : null}
                        onChange={(value: Dayjs | null) => {
                            setStartDate(value?.format("YYYY-MM-DD") || "");
                        }}
                        slotProps={{ desktopPaper: { elevation: 3 } }}
                        sx={{
                            "& .MuiSvgIcon-root": { fill: purple },
                            "& .MuiOutlinedInput-root": { borderRadius: 2 },
                        }}
                    />
                    <Box p={1}></Box>
                    <DatePicker
                        label="End Date"
                        format="DD-MM-YYYY"
                        disableFuture
                        value={endDate ? dayjs(endDate, "YYYY-MM-DD") : null}
                        onChange={(value: Dayjs | null) => {
                            setEndDate(value?.format("YYYY-MM-DD") || "");
                        }}
                        slotProps={{ desktopPaper: { elevation: 3 } }}
                        sx={{
                            "& .MuiSvgIcon-root": { fill: purple },
                            "& .MuiOutlinedInput-root": { borderRadius: 2 },
                        }}
                    />
                </Box>
            </Box>
        );
    }
}
